module.exports = __webpack_public_path__ + "assets/security-1-0d5973c50094a45d1ab265f4591c621f.svg";